import { useQuery } from "@tanstack/react-query";

import { queryKeys } from "@/lib/query-keys";
import { stockTransformationService } from "@/services/stock-transformation";

import type { GetRepackShrinkageReq } from "@artisancode/api-types";

export function useRepackShrinkage(params: GetRepackShrinkageReq) {
  return useQuery({
    queryKey: queryKeys.stockTransformations.repackShrinkage({ ...params }),
    queryFn: () => stockTransformationService.getRepackShrinkage(params),
  });
}
